/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'prismjs/themes/prism-okaidia.css'

// Global FontAwesome library setup - prevents hydration flash
import { library, config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'

// Prevent FA from adding CSS automatically (we import it above)
config.autoAddCss = false

// Add icons to global library
library.add(faGithub, faLinkedin)
